module.exports = __webpack_public_path__ + "step-4-desktop.ec697cd16f7b6460d113.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/payment-catalog/step-4-desktop.png
// module id = ../../../../../src/assets/payment-catalog/step-4-desktop.png
// module chunks = styles